// Package imports:
import React from 'react';
// Component imports:
import HeadSection from '../../ui-elements/HeadSection/HeadSection';
import KeldanAppDisclaimerComp from './KeldanAppDisclaimerComp/KeldanAppDisclaimerComp';

const KeldanAppDisclaimer: React.FC = () => {
    return (
        <div className="main KCL__Skilmalar KCL__KeldanAppSkilmalar">
            <div className='container'>
                <HeadSection
                    title="Keldan App skilmálar"
                    description={
                        <p>Notendur og áskrifendur Keldan App samþykkja eftirfarandi skilmála:</p>
                    }
                />
                <div className='section__body'>
                    <div>
                        <KeldanAppDisclaimerComp /> 
                    </div>
                </div>
            </div>
        </div>
    )
}

export default KeldanAppDisclaimer;